export const firebaseConfig = {
  apiKey: "AIzaSyC_IoD9tfxDeGx2TRUbx3LWxkimrvSmDYI",
  authDomain: "interact-adapt-painguide.firebaseapp.com",
  projectId: "interact-adapt-painguide",
  storageBucket: "interact-adapt-painguide.firebasestorage.app",
  messagingSenderId: "1077250270070",
  appId: "1:1077250270070:web:c5031f1cee56147be89057",
};
